/* eslint-disable no-else-return */
/* eslint-disable no-unreachable */
/* eslint-disable func-names */
// Modules
const {
  object,
  string,
  number,
  array,
  addMethod,
  boolean,
  date,
} = require("yup");

// const getBankDetails = require("../../shared/functions/getBankDetails");
const verifyIdNumber = require("../../shared/functions/verifyIdNumber");
// const getProvinceDetails = require("../../shared/functions/getProvinceDetails");

// Constants
const {
  countryCodes,
  provinces,
  // banks
} = require("../../shared/constants");

addMethod(string, "requiredIf", function (bool, message) {
  if (!bool) {
    return this.nullable();
  }

  return this.required(message || "Required");
});

addMethod(number, "requiredIf", function (bool, message) {
  if (!bool) {
    return this.nullable();
  }

  return this.required(message || "Required");
});

addMethod(date, "requiredIf", function (bool, message) {
  if (!bool) {
    return this.nullable();
  }

  return this.required(message || "Required");
});

addMethod(number, "requiredIf", function (bool, message) {
  if (!bool) {
    return this.nullable();
  }

  return this.required(message || "Required");
});

addMethod(string, "foundInObject", function (objArray, message) {
  return this.test("isfoundInObject", function (value) {
    const { path, createError } = this;

    // Check if the provided objArray is a valid non-empty array
    if (!Array.isArray(objArray) || objArray.length === 0) {
      return createError({
        path,
        message: `Invalid array provided to test "foundInObject" for ${path}`,
      });
    }

    // Check if the value exists in the objArray
    const found = objArray.some(obj => obj.value === value);

    if (value && !found) {
      return createError({
        path,
        message: message || `Invalid ${path}`,
      });
    }

    return true;
  });
});

addMethod(string, "foundInArray", function (arr, message) {
  return this.test("isFoundInArray", function (value) {
    const { path, createError } = this;

    if (!arr || !Array.isArray(arr) || !arr.length) {
      createError({
        path,
        message: `Invalid array provided to test "foundInArray" for ${path}`,
      });
    }

    if (value) {
      const index = arr.findIndex(v => v === value);

      if (index === -1) {
        return createError({
          path,
          message: message || `Invalid ${path}`,
        });
      }
    }

    return true;
  });
});

addMethod(number, "foundInArray", function (arr, message) {
  return this.test("isFoundInArray", function (value) {
    const { path, createError } = this;

    if (!arr || !Array.isArray(arr) || !arr.length) {
      createError({
        path,
        message: `Invalid array provided to test "foundInArray" for ${path}`,
      });
    }

    if (value) {
      const index = arr.findIndex(v => v === value);

      if (index === -1) {
        return createError({
          path,
          message: message || `Invalid ${path}`,
        });
      }
    }

    return true;
  });
});

addMethod(array, "foundInArray", function (arr, message) {
  return this.test("isFoundInArray", function (value) {
    const { path, createError } = this;

    if (!arr || !Array.isArray(arr) || !arr.length) {
      createError({
        path,
        message: `Invalid array provided to test "foundInArray" for ${path}`,
      });
    }
    if (!value || !Array.isArray(value) || !value.length) {
      createError({
        path,
        message: message || `Invalid ${path} provided`,
      });
    }

    const match = value.every(v => arr.includes(v));

    if (!match) {
      return createError({
        path,
        message: message || `Invalid ${path}`,
      });
    }

    return true;
  });
});

addMethod(string, "name", function (validMessage, shortMessage) {
  return this.min(2, shortMessage || validMessage || "Too short").matches(
    /^[a-z ,.'-]+$/i,
    validMessage || "Invalid"
  );
});

addMethod(string, "phone", function (message) {
  return this.matches(/^\+27[0-9]{9}$/g, message || "Invalid");
});

// id types
const ID = "RSAID";
const PASSPORT = "PASSPORT";
// genders
const MALE = "M";
const FEMALE = "F";
// payment options
const BANK = "bank";
const E_WALLET = "eWallet";
// bank types
const CHEQUE = 1;
const SAVINGS = 2;
// bank
// const BRANCH_CODES = banks.map(b => b.branchCode);
// const BANK_NAMES = banks.map(b => b.value);
// address
const PROVINCE_ARRAY = provinces.map(p => p.value);

// const isString = val => typeof val === "string";

const validateDealerObject = async data => {
  if (data.refs_identity_doc_type === ID) {
    verifyIdNumber(
      data.identification_no,
      data.date_of_birth,
      data.refs_gender,
      data.nationality
    ).then(result => {
      if (!result.valid) {
        return {
          status: "error",
          message: result.message,
        };
      }
    });
  }

  const paymentIsBank = data.refs_payment_type === BANK;
  const passportIsIdType = data.refs_identity_doc_type === PASSPORT;

  const dealerSchema = object({
    agreed_to_rica_terms: boolean().required(true),
    alt_phone: string()
      .min(12, "Alternative Phone number is not valid")
      .max(12, "Alternative Phone number is not valid")
      .phone("Invalid phone number")
      .nullable(),
    city: string().min(2, "Invalid city (2+ letters)").required(),
    company_name: string()
      .min(2, "Invalid Company Name (2+ letters)")
      .nullable(),
    country: string().foundInObject(countryCodes, "Invalid Country").required(),
    date_of_birth: date().required("Date of birth is required"),
    e_wallet_link: string().nullable(),
    email: string().email().required("Email is required"),
    first_name: string().min(2, "Invalid first name (2+ letters)").required(),
    id_photo_url: string().url("Invalid ID Photo").required(),
    identification_no: string().required(),
    last_updated_by_auth_id: string()
      .uuid("Updated Auth ID Is Required")
      .required(),
    middle_name: string().nullable(),
    nationality: string()
      .foundInObject(countryCodes, "Invalid nationality")
      .required(),
    operator_id: string().nullable(),
    parent_id: number().required(),
    passport_expiry_date: date().requiredIf(
      passportIsIdType,
      "Passport expiry date required"
    ),
    passport_issue_date: date().requiredIf(
      passportIsIdType,
      "Passport issue date required"
    ),
    person_photo_url: string().url("Invalid person photo").required(),
    phone: string()
      .min(12, "Phone number is not valid")
      .max(12, "Phone number is not valid")
      .phone("Invalid phone number")
      .required("Phone number is required"),
    postal_code: string()
      .matches(/^[0-9]{4}$/g, "Invalid Postal Code")
      .required(),
    province: string().foundInArray(PROVINCE_ARRAY).required(),
    refs_gender: string()
      .foundInArray([MALE, FEMALE], "Invalid gender")
      .required(), // Enum in DB
    refs_bank_account_type: number()
      .foundInArray([CHEQUE, SAVINGS], "Invalid bank account type")
      .requiredIf(paymentIsBank, "Please select a bank account type"),
    refs_identity_doc_type: string()
      .foundInArray([ID, PASSPORT], "Invalid ID type")
      .required(), // Enum in DB
    refs_payment_type: string()
      .foundInArray([BANK, E_WALLET], "Invalid payment type")
      .required(), // Enum in DB
    refs_shirt_size: string(), // Enum in DB
    refs_type_id: number().required(),
    street: string().min(2, "Street too short").required(),
    submitted_by: number().required(),
    submitted_by_auth_id: string()
      .uuid("Submitted By Auth ID Is Required")
      .required(),
    suburb: string().name("Invalid suburb (2+ letters)").required(),
    surname: string().name("Invalid Surname (2+ letters only)").required(),
  });

  // refs_payment_type
  // refs_gender;
  // refs_identity_doc_type;
  // refs_shirt_size;

  return new Promise((resolve, reject) => {
    dealerSchema
      .validate(data)
      .then(() => {
        resolve({
          validated: true,
        });
      })
      .catch(err => {
        reject({
          validated: false,
          message: err.message,
        });
      });
  });
};

module.exports = validateDealerObject;
